<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
  import {getSessionStore} from '@/config/mUtils'

  export default {
    name: 'app',
    watch: {
      $route(to, form){
        const noAuthUrl = ['/login','/download','/handheldDownload?handsetOrPhone=1','/handheldDownload?handsetOrPhone=2'];
        if (!getSessionStore('token') && !noAuthUrl.includes(this.$route.fullPath)) {
          this.$router.push({path: '/login'});
        }
      }
    }
  };
</script>



<style lang="scss">
.select-map {
  position: relative;
  width: auto;
  padding: 15px;
  line-height: 30px;
  background: #fff;
  font-size: 14px;
  border-radius: 5px;
  .title {
    width: 100%;
    text-align: center;
  }
  i {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer
  }
  i:hover {
    background: rgba(27, 141, 148, .7);
  }
  .but {
    display: flex;
    justify-content: space-around;
    margin-top: 5px;
    input {
      padding: 5px 20px;
      border-radius: 3px;
      background: #169bd5;
      color: #fff;
      cursor: pointer;
    }
  }
}
.searchBtn{
  background-color:#335483!important;
  color:#fff!important;
  border: none!important;
  &:hover{
    opacity: 0.8;
  }
  &:active{
    background-color: #1b2d49 !important;
    color:#fff;
  }
}
.resetBtn{
  background-color: #A4ADB3 !important;
  color: #fff !important;
  border: none!important;
  &:hover{
    opacity: 0.8;
  }
  &:active{
    background-color: #7c8287 !important;
    color:#fff;
  }
}
.yellow-bg{
  background-color: rgb(255,153, 51) !important;
  color: #fff !important;
  border: none!important;
  &:hover{
    opacity: 0.8;
  }
}
.amap-sug-result{
  z-index: 999999!important;
}
html {
  overflow-y: hidden;
}
</style>
